import { gql } from '@apollo/client'

export const ADD_HR_ROLE_TO_EMPLOYEE = gql`
  mutation AddHrRoleToEmployee($employeeId: HashedId!, $roleName: String!, $hrVisibilityExcluded: Boolean!) {
    addHrRoleToEmployee(employeeId: $employeeId, roleName: $roleName, hrVisibilityExcluded: $hrVisibilityExcluded)
  }
`

export const REMOVE_HR_ROLE_FROM_EMPLOYEE = gql`
  mutation RemoveHrRoleFromEmployee($employeeId: HashedId!, $roleIds: [HashedId!]!, $countryRoleName: String!) {
    removeHrRoleFromEmployee(employeeId: $employeeId, roleIds: $roleIds, countryRoleName: $countryRoleName)
  }
`

export const REMOVE_DOWNLOADER_ROLE_FROM_EMPLOYEE = gql`
  mutation RemoveDownloaderRoleFromEmployee($employeeId: HashedId!) {
    removeDownloaderRoleFromEmployee(employeeId: $employeeId)
  }
`

export const ADD_DOWNLOADER_ROLE_TO_EMPLOYEE = gql`
  mutation AddDownloaderRoleToEmployee($employeeId: HashedId!) {
    addDownloaderRoleToEmployee(employeeId: $employeeId)
  }
`
